import React, { useEffect, useState } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { ProblemSolution } from './components/ProblemSolution';
import { ProductDetails } from './components/ProductDetails';
import { Pricing } from './components/Pricing';
import { TrustAndFAQ } from './components/TrustAndFAQ';
import { Closing } from './components/Closing';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the first hero button (approx 600px)
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-base text-dark font-montserrat selection:bg-brand selection:text-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSolution data-id="element-2" />
      <ProductDetails data-id="element-3" />
      <Pricing data-id="element-4" />
      <TrustAndFAQ data-id="element-5" />
      <Closing data-id="element-6" />

      <PurchasePopup data-id="element-7" />

      {/* Mobile Sticky CTA */}
      <div className={`fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 p-4 z-40 md:hidden transition-transform duration-300 ease-in-out shadow-[0_-4px_10px_rgba(0,0,0,0.05)] ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-8">
        <a href="#pricing" onClick={() => {
        const fbq = (window as any).fbq;
        if (typeof fbq === 'function') fbq('track', 'InitiateCheckout');
      }} className="block w-full bg-brand text-dark text-center font-montserrat font-bold uppercase tracking-wider py-4 px-4 rounded shadow-sm active:scale-95 transition-transform" data-id="element-9">
          → QUIERO MI MEGAKIT
        </a>
      </div>
    </div>;
}